'use strict';

customerZone

    .controller('TopupHistory', ['$log', 'utils', 'Session', 'UnleashedClient', function($log, utils, session, api){

        var self = this;
        self.xMonths = '1';
        self.history = [];

        var filters = function(pageNumber){
            return {
                dateFrom: moment().subtract(self.xMonths, 'month').format('DD/MM/YYYY'),
                dateTo: moment().format('DD/MM/YYYY'),
                pageNumber: pageNumber
            };
        };

        self.loadTopups = function(page){
            return api.getTopupHistory(session.subscriber().id, filters(page))
                .catch(function (error) {
                    $log.error('failed topup history', error);
                    throw error;
                });
        };

        self.resetHistory = function() {
            self.history = undefined;
        };

    }]);
